import { createApi } from '@shared/redux/createApi';

const tags = { banks: 'banks' };

const buildBankFormData = (data) => {
  const formData = new FormData();
  const fields = ['name', 'domain', 'order', 'is_main', 'main_order'];
  fields.forEach((key) => {
    if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
      formData.append(key, data[key]);
    }
  });
  if (data.logo instanceof File) {
    formData.append('logo', data.logo);
  }
  return formData;
};

export const deeplinksApi = createApi({
  reducerPath: 'deeplinksApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getBankList: builder.query({
      query: () => ({ url: '/banks/all', method: 'get' }),
      transformResponse: (response) => response || [],
      providesTags: [tags.banks],
    }),
    getBank: builder.query({
      query: (bankId) => ({ url: `/banks/${bankId}`, method: 'get' }),
    }),
    createBank: builder.mutation({
      queryFn: async (data, _api, _extra, baseQuery) => {
        const formData = buildBankFormData(data);
        return baseQuery({ url: '/banks', method: 'post', body: formData });
      },
      invalidatesTags: [tags.banks],
    }),
    updateBank: builder.mutation({
      queryFn: async ({ bankId, ...data }, _api, _extra, baseQuery) => {
        const formData = buildBankFormData(data);
        return baseQuery({ url: `/banks/${bankId}`, method: 'patch', body: formData });
      },
      invalidatesTags: [tags.banks],
    }),
    deleteBank: builder.mutation({
      query: (bankId) => ({ url: `/banks/${bankId}`, method: 'delete' }),
      invalidatesTags: [tags.banks],
    }),
  }),
});

export const {
  useGetBankListQuery,
  useGetBankQuery,
  useCreateBankMutation,
  useUpdateBankMutation,
  useDeleteBankMutation,
} = deeplinksApi;
